import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {ANTIBODY_DOMAIN_HEIGHT, ANTIBODY_DOMAIN_WIDTH} from 'antibodies/AntibodyConstants';

interface AntibodyDomainLabelProps {
  color: string;
  height?: number;
  text: string;
  width?: number;
}

/**
 * A short, mostly-transparent, rectangular label to overlay on an antibody domain.
 * This is an SVG component, so all units are 'abstract user units', relative to the SVG viewbox.
 * @param color The color of the text on the label
 * @param height The height of the label
 * @param text The text of the label
 * @param width The width of the label
 */
export default function AntibodyDomainLabel({
  color,
  height = ANTIBODY_DOMAIN_HEIGHT / 4,
  text,
  width = ANTIBODY_DOMAIN_WIDTH / 2,
}: AntibodyDomainLabelProps): JSX.Element {
  return (
    <>
      <g height={height} width={width}>
        <g transform={`translate(${width / 2}, ${height / 2})`}>
          <text
            className={css(styles.text)}
            dominantBaseline="central"
            fontSize={(5 * height) / 8}
            textAnchor="middle"
            fill={color}
          >
            {text}
          </text>
        </g>
      </g>
    </>
  );
}

const styles = StyleSheet.create({
  text: {
    userSelect: 'none',
    cursor: 'pointer',
  },
});
